module.exports = __webpack_public_path__ + "static/media/shareBack.3fa778ce.png";